<template>
  <div class="p-0 dropdownParent">
    <!-- {{keyItem}} -->
    <div class="input-icons" style="position: relative">
      <input
        @focus="dropdown()"
        @click="dropdown()"
        :value="defaultSelected"
        @keyup="searchCombo($event, keyItem)"
        @keydown="keyHandler($event, keyItem)"
        @blur="CheckEmpty"
        :id="idInput"
        :disabled="disabled"
        type="text"
        class="input-drop-down form-control pl-4"
        :class="ClassProps"
        autocomplete="off"
        :name="keyItem"
      />
      <i v-if="!noIcone" :disabled="disabled" :name="keyItem" @click="disabled ? Void(0) : dropdown()" class="fad fa-chevron-double-down icon Pointer"></i>
      <i v-if="!noIcone && ActiveDelete" :disabled="disabled" :name="keyItem" @click="disabled ? Void(0) : deleteAll()" class="fad ml-3 fa-times text-danger icon Pointer"></i>
    </div>
    <div class="dropdown dropdownParent" :name="keyItem" :id="'dropdown' + keyItem">
      <div class="dropdown-content text-bold dropdownParent" :name="keyItem" :class="keyItem" :id="'dropdowntest' + keyItem" style="z-index: 100">
        <ul class="m-0 mr-0 p-0" :name="keyItem" :id="'ultest' + keyItem">
          <li v-for="(element, key) in comboValues" :key="key" :id="element.id + '-' + keyItem" :name="keyItem" class="list-dropdown Pointer">
            <a @keypress="arrowfun($event)" tabindex="-1" @click="selectCombo(element.name, element.id, keyItem, idInput, element)" :name="keyItem" class="list-item"> {{ element.name }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['idinput', 'keyItem', 'IsDefault', 'SelectAll', 'defaultFirst', 'defaultvalue', 'action', 'method', 'edit', 'code', 'grp', 'noIcone', 'disabled', 'ClassProps', 'LazyLoad', 'ActiveDelete', 'queryString', 'GridRowNum'],
  data() {
    return {
      ClickOkF: ['icon', 'list-dropdown', 'list-item', 'input-drop-down', 'dropdownParent'],
      comboValues: [],
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      idInput: '',
      defaultSelected: '',
      ResultEmited: false,
    }
  },
  methods: {
    dropdown() {
      this.LoadCombo()
      if (this.idInput == 'ManbaBazaryabi') {
      }

      if (this.comboValues == []) {
        this.dropdown()
      } else if (!this.edit) {
        var allshows = document.querySelectorAll('.dropdown-content.' + this.keyItem)
        allshows = Array.prototype.slice.call(allshows)
        document.getElementById('dropdowntest' + this.keyItem).style.display = 'block'
        allshows.forEach((element) => {
          element.style.display = 'none'
        })
        document.getElementById('dropdowntest' + this.keyItem).style.display = 'block'
        var list = document.getElementById('ultest' + this.keyItem)
        var selecteds = document.getElementsByClassName('selected')
        selecteds = Array.prototype.slice.call(selecteds)

        selecteds.forEach((element) => {
          element.classList.remove('selected')
        })
        if (this.idInput == 'ManbaBazaryabi') {
        }

        if (list.getElementsByTagName('li')[0]) {
          list.getElementsByTagName('li')[0].children[0].classList.add('selected')
          document.getElementsByClassName('dropdown-content')[0].scrollTop = list.getElementsByTagName('li')[0].children[0].offsetTop
          document.getElementById('dropdowntest' + this.keyItem).style.display = 'block'
        }
      }
    },
    keyHandler(e) {
      var parent = document.getElementById('dropdowntest' + this.keyItem)
      var selected = parent.getElementsByClassName('selected')[0]
      var wholelist = parent.getElementsByClassName('list-dropdown')
      if (selected != undefined) {
        var list = selected.closest('ul')
        var liList = list.getElementsByTagName('li')
        liList = Array.prototype.slice.call(liList)
        liList = liList.filter((x) => x.style.display != 'none')
        var tags = []
        liList.forEach((element) => {
          tags.push(element.children[0])
        })
        var indexOfels = tags.indexOf(selected)
        //Arrpw UP
        if (e.which === 38) {
          if (indexOfels > 0) {
            for (let index = indexOfels - 1; index >= 0; index--) {
              const element = tags[index]
              if (element.style.display != 'none') {
                selected.classList.remove('selected')
                element.classList.add('selected')
                document.getElementsByClassName('selected')[0].closest('.dropdown-content').scrollTop = tags[indexOfels - 1].offsetTop
                break
              }
            }
          }
          //Arrow Down
        } else if (e.which === 40) {
          if (indexOfels < tags.length - 1) {
            for (let index = indexOfels + 1; index <= tags.length - 1; index++) {
              const element = tags[index]
              if (element.style.display != 'none') {
                selected.classList.remove('selected')
                element.classList.add('selected')
                document.getElementsByClassName('selected')[0].closest('.dropdown-content').scrollTop = tags[indexOfels + 1].offsetTop
                break
              }
            }
            // if (tags[indexOfels +1 ].style.display == "block") {
            //     tags[indexOfels +1 ].classList.add("selected")
            //     console.log(document.getElementsByClassName('selected')[0]);
            //     document.getElementsByClassName('selected')[0].closest('.dropdown-content').scrollTop  = tags[indexOfels +1 ].offsetTop
            // }
          }
        }
        // ENTER
        else if (e.which === 13) {
          selected.click()
        } else if (e.which === 27) {
          document.getElementsByClassName('selected')[0].closest('.dropdown-content').style.display = 'none'
        } else if (e.which === 9) {
          document.getElementsByClassName('selected')[0].closest('.dropdown-content').style.display = 'none'
        }
      } else {
        if (wholelist.length > 0) {
          wholelist[0].classList.add('selected')
          selected = []
          selected.push(wholelist[0])
        }
      }
    },
    Clickhandler(e) {
      var IsDropdown = false
      this.ClickOkF.forEach((element) => {
        if (e.target.classList.contains(element) && e.target.attributes['name'] && e.target.attributes['name'].value == this.keyItem) {
          IsDropdown = true
        }
      })
      if (!IsDropdown) {
        var temp = document.getElementsByClassName('dropdown-content')
        temp = Array.prototype.slice.call(temp)
        temp.forEach((dropdown) => {
          if (dropdown.attributes['name'].value == this.keyItem) {
            dropdown.style.display = 'none'
          }
        })
        // this.leave()
      }
    },
    selectCombo(elName, id, key, idInput, Selectedelement) {
      var temp = document.getElementsByClassName('dropdown-content')
      temp = Array.prototype.slice.call(temp)
      temp.forEach((element) => {
        element.style.display = 'none'
      })
      document.getElementById(idInput).blur()
      this.defaultSelected = elName

      this.$emit('ResultCombo', {
        name: elName,
        id: id,
        key: key,
        element: Selectedelement,
      })
      this.$emit('sanadrizComboVlueResult', [
        {
          name: elName,
          id: id,
          key: key,
          element: Selectedelement,
        },
        this.GridRowNum,
      ])

      this.ResultEmited = true
    },
    leave(id) {
      if (!this.ResultEmited) {
        document.getElementById(this.idInput).value = ''
      }
      if (document.getElementById(this.idInput).value == '') {
        this.$emit('ResultCombo', {
          name: '',
          id: null,
          key: this.keyItem,
          element: null,
        })
        this.$emit('sanadrizComboVlueResult', [
          {
            name: '',
            id: null,
            key: this.keyItem,
            element: null,
          },
          this.GridRowNum,
        ])
      }
      document.getElementById('dropdowntest' + this.keyItem).style.display = 'none'
    },
    searchCombo(e, key) {
      if (e.which != 38 && e.which != 40 && e.which != 13) {
        var serchfield = e.target.value
        var list = document.getElementById('ultest' + this.keyItem).children
        list = Array.prototype.slice.call(list)
        var selected = false
        list.forEach((ele) => {
          var serchabel = ele.children[0].textContent
          if (serchabel.indexOf(serchfield) <= -1) {
            ele.style.display = 'none'
          } else {
            if (!selected) {
              var selecteds = document.getElementsByClassName('selected')
              selecteds = Array.prototype.slice.call(selecteds)
              selecteds.forEach((element) => {
                element.classList.remove('selected')
              })
              ele.children[0].classList.add('selected')
              // console.log("ele", ele);
              selected = true
            }

            ele.style.display = 'block'
          }
        })
      }
    },
    setDefaultval(defaultid) {
      if (defaultid != null) {
        this.comboValues.forEach((element) => {
          if (element.id == defaultid) {
            this.defaultSelected = element.name
            this.$emit('ResultCombo', {
              name: element.name,
              id: element.id,
              key: this.keyItem,
              element: element,
              IsDefault: true,
            })

            this.$emit('sanadrizComboVlueResult', [
              {
                name: element.name,
                id: element.id,
                key: this.keyItem,
                element: element,
                IsDefault: true,
              },
              this.GridRowNum,
            ])
          }
        })
      }
    },
    setdefaultFirst() {
      var element = this.comboValues[0]
      this.defaultSelected = element.name
      this.$emit('ResultCombo', {
        name: element.name,
        id: element.id,
        key: this.keyItem,
        element: element,
        IsDefault: true,
      })
      this.$emit('sanadrizComboVlueResult', [
        {
          name: element.name,
          id: element.id,
          key: this.keyItem,
          element: element,
          IsDefault: true,
        },
        this.GridRowNum,
      ])
    },
    CheckEmpty() {
      if (document.getElementById(this.idInput).value == '') {
        this.$emit('ResultCombo', {
          name: '',
          id: null,
          key: this.keyItem,
          element: null,
        })
        this.$emit('sanadrizComboVlueResult', [
          {
            name: '',
            id: null,
            key: this.keyItem,
            element: null,
          },
          this.GridRowNum,
        ])
      }
    },
    simulator() {
      document.getElementById(this.idInput).focus()
    },
    LoadCombo() {
      if (this.comboValues.length < 1) {
        if (!this.disabled || this.defaultvalue) {
          if (this.action == 'TblCrmCombo/GetUserDatails' || this.action.indexOf('GetCostomerProduct') >= 0 || this.grp == 45 || this.grp == 42 || this.grp == 41) {
            if (this.action == 'TblCrmCombo/GetUserDatails') {
              if (this.$store.getters.GetUserDatails != null && this.$store.getters.GetUserDatails.length > 0) {
                this.comboValues = this.$store.getters.GetUserDatails
                if (this.defaultvalue) {
                  this.setDefaultval(this.defaultvalue)
                }
                if (this.defaultFirst) {
                  this.setdefaultFirst()
                }
              } else {
                this.PostData()
              }
            } else if (this.grp == 45) {
              if (this.$store.getters.GetTblComboGrpId45.length > 0) {
                this.comboValues = this.$store.getters.GetTblComboGrpId45
                if (this.defaultvalue) {
                  this.setDefaultval(this.defaultvalue)
                }
                if (this.defaultFirst) {
                  this.setdefaultFirst()
                }
              } else {
                this.PostData()
              }
            } else if (this.action.indexOf('GetCostomerProduct') > 0) {
              if (this.$store.getters.GetCostomerProduct.length > 0) {
                this.comboValues = this.$store.getters.GetCostomerProduct
                if (this.defaultvalue) {
                  this.setDefaultval(this.defaultvalue)
                }
                if (this.defaultFirst) {
                  this.setdefaultFirst()
                }
              } else {
                this.PostData()
              }
            } else if (this.grp == 41) {
              if (this.$store.getters.GetTblComboGrpId41.length > 0) {
                this.comboValues = this.$store.getters.GetTblComboGrpId41
                if (this.defaultvalue) {
                  this.setDefaultval(this.defaultvalue)
                }
                if (this.defaultFirst) {
                  this.setdefaultFirst()
                }
              } else {
                this.PostData()
              }
            } else if (this.grp == 42) {
              if (this.$store.getters.GetTblComboGrpId42.length > 0) {
                this.comboValues = this.$store.getters.GetTblComboGrpId42
                if (this.defaultvalue) {
                  this.setDefaultval(this.defaultvalue)
                }
                if (this.defaultFirst) {
                  this.setdefaultFirst()
                }
              } else {
                this.PostData()
              }
            }
          } else {
            this.PostData()
          }
        }
      } else {
        this.$emit('ResultCombo', {
          name: '',
          id: null,
          key: this.keyItem,
          element: null,
        })
        this.$emit('sanadrizComboVlueResult', [
          {
            name: '',
            id: null,
            key: this.keyItem,
            element: null,
          },
          this.GridRowNum,
        ])
      }
    },
    PostData() {
      if (this.queryString) {
        var querystring = JSON.stringify(this.queryString)
        querystring = querystring.replace('{', '')
        querystring = querystring.replace('}', '')
        querystring = querystring.replace(/"/g, '')
        querystring = querystring.replace(/:/g, '=')
        querystring = querystring.replace(/,/g, '&')
        this.DataAxios_GetData.Action = this.action + '?' + querystring
      }
      this.$PostData(this.DataAxios_GetData).then((data) => {
        if (data.status != 'Not Ok') {
          if (!data[0].id) {
            data.forEach((element) => {
              element.id = element.Id
              element.name = element.Name
              delete element.Name
              delete element.Id
            })
          }
          this.comboValues = data
          if (this.SelectAll) {
            this.comboValues.push({ id: 'XXX', name: 'همه' })
          }
          if (this.defaultvalue) {
            if (this.action == 'TblCrmCombo/GetUserDatails') {
              this.$store.commit('SetUserDatails', this.comboValues)
            }
            if (this.grp == 45) {
              // this.$store.state.TblComboGrpId45 = this.comboValues
              this.$store.commit('SetTblComboGrpId45', this.comboValues)
            }
            if (this.grp == 41) {
              // this.$store.state.TblComboGrpId41 = this.comboValues
              this.$store.commit('SetTblComboGrpId41', this.comboValues)
            }
            if (this.grp == 42) {
              // this.$store.state.TblComboGrpId42 = this.comboValues
              this.$store.commit('SetTblComboGrpId42', this.comboValues)
            }
            if (this.action.indexOf('GetCostomerProduct') > 0) {
              this.$store.commit('SetCostomerProduct', this.comboValues)
              // this.$store.state.GetCostomerProduct = this.comboValues
            }
            this.setDefaultval(this.defaultvalue)
          }
          if (this.defaultFirst) {
            this.setdefaultFirst()
          }
          if (this.IsDefault) {
            var id = this.comboValues.filter((x) => x.DefultItem == true).lenght > 0 ? this.comboValues.filter((x) => x.DefultItem == true)[0].id : null
            if (id > 0) this.setDefaultval(id.id)
          }
        } else {
          this.$mySweetDefaultTost('هشدار', data.message, 'warning', 2000)
        }
      })
    },
    deleteAll() {
      this.defaultSelected = ''
      this.$emit('deleteSelected', {
        name: '',
        id: '',
        key: this.keyItem,
        element: '',
        deleted: true,
      })
      this.$emit('sanadrizComboVlueResult', [
        {
          name: '',
          id: '',
          key: '',
          element: '',
          deleted: true,
        },
        this.GridRowNum,
      ])

      this.ResultEmited = true
    },
  },
  mounted() {
    this.idInput = this.idinput
    window.addEventListener('click', this.Clickhandler)
    this.DataAxios_GetData.Action = this.action
    this.DataAxios_GetData.Method = this.method
    this.DataAxios_GetData.ArryfildValue = this.code == null ? { Id: this.grp } : { filter: this.code, grp: this.grp }
    if (!this.LazyLoad) {
      this.LoadCombo()
    }
  },
}
// CHEKIN
</script>

<style scoped>
.input-icons i {
  position: absolute;
  left: 0;
  top: 15%;
  font-size: x-small;
}
.input-icons {
  width: 100%;
}
.icon {
  float: left;
  padding: 10px;
  min-width: 40px;
}
.input-field {
  width: 100%;
  padding: 10px;
  text-align: center;
}
.dropdown {
  position: relative;
  display: inline-block;
  right: 0;
  width: 100%;
  margin: 0 !important;
}
/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute !important;
  width: 100%;
  background-color: var(--sidebar-action-bg);
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 10;
}
/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  display: block;
}
div.dropdown-content {
  max-height: 25vh;
  overflow-y: scroll;
  position: absolute;
}
ul {
  list-style-type: none !important;
}
.list-item.selected {
  color: white !important;
  background: cornflowerblue !important;
  list-style-type: none !important;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  text-decoration: none;
  background-color: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}
.CustomFormControl {
  border: 1px;
  background: transparent;
  widows: 100%;
  height: 100%;
  margin: 0;
}
.CustomFormControl:focus {
  outline: none !important;
  border: 1px solid #3072ff;
  box-shadow: 0 0 10px #71b8ce;
}
</style>
